export const replacePlaceholders = (str: string, placeholders: any) => str.replace(/{{(.*?)}}/g, (match, p1) => placeholders[p1] || match);

// export const replacePlaceholders = (str: string, placeholders: any) => {
//   const appendedValues: string[] = []; // Array to store appended values
//   const replacedString = str.replace(/{{(.*?)}}/g, (match: string, p1: string) => {
//     let value: any = placeholders[p1] || match; // Placeholder value or original match
//     // Check if value contains '$'
//     if (value.includes('($)')) {
//       const dollarIndex = value.indexOf('($)');
//       // Extract substring after '$'
//       const appendedValue = value.slice(dollarIndex);
//       value = value.slice(0, dollarIndex);
//       // Push the extracted value to the array
//       appendedValues.push(appendedValue);
//     }
//     return value;
//   });

//   if (appendedValues.length > 0) {
//     return `${replacedString}${appendedValues.join('')}`;
//   } 

//   return replacedString;
// };